// Comun a toda la aplicaion del cliente, busca el token y lo actualiza
import axios from 'axios'
import { TOKEN_KEY } from '../constantes/localStorageKeys'

const searchLocalToken = () => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) {
    return {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    }
  }
  return {}
}

export const API = axios.create({
  // baseURL: 'http://localhost:5001',
  // baseURL: 'http://dev2.einatec.com:8998/',
  baseURL: 'https://palex.einatec.com/',

  // baseURL: process?.env?.NODE_ENV === "development" ? "http://localhost:5001" : "/",
  headers: searchLocalToken(),
})

export const updateToken = () => {
  API.defaults.headers = {
    ...API.defaults.headers,
    ...searchLocalToken(),
  }
}
